export type WalletPlatform = 'ios' | 'android' | 'web'

export type WalletLink = {
	ios?: string | null
	android?: string | null
	web?: string | null
}

/** Best-effort platform detection from the user-agent for wallet deep links. */
export const detectWalletPlatform = (
	userAgent: string = typeof navigator !== 'undefined' ? navigator.userAgent : ''
): WalletPlatform => {
	if (/iPhone|iPad|iPod/.test(userAgent)) {
		return 'ios'
	}
	if (/Android/.test(userAgent)) {
		return 'android'
	}
	return 'web'
}

/**
 * Picks the wallet URL for the given platform, falling back to the web link when
 * the platform-specific link is missing.
 */
export const selectWalletUrl = (
	platform: WalletPlatform,
	walletLink: WalletLink | undefined | null
): string | undefined => {
	if (!walletLink) {
		return undefined
	}
	const { ios, android, web } = walletLink
	if (platform === 'ios' && ios) {
		return ios
	}
	if (platform === 'android' && android) {
		return android
	}
	return web ?? undefined
}
